'use client'
import { useCountry } from '@susu/headless-commerce/contexts/country/client'
import { useLocale } from '@susu/headless-commerce/contexts/locale/client'
import type {
  Button,
  PromotionEvents,
} from '@susu/headless-commerce/gql/generated/graphql'
import { usePageType } from '@susu/headless-commerce/hooks/usePageType'
import {
  trackClickPromotion,
  trackImpressionPromotion,
} from '@susu/headless-commerce/utils/tracking/tracking'
import { type ReactNode, useCallback, useEffect, useRef } from 'react'

export type ClientButtonProps = {
  buttonClasses: string
  buttonData: Button
  buttonHref: string
  buttonRichText: ReactNode
}

export default function ClientButton({
  buttonData,
  buttonHref,
  buttonRichText,
  buttonClasses,
}: Readonly<ClientButtonProps>) {
  const locale = useLocale()
  const country = useCountry()
  const buttonRef = useRef<HTMLAnchorElement>(null)
  const pageType = usePageType()

  const handleButtonClick = useCallback(() => {
    trackClickPromotion(
      buttonRef,
      buttonData?.link?.promotionEvents as PromotionEvents,
      pageType,
      {
        locale,
        country,
      },
    )
  }, [buttonData, locale, country, pageType])

  useEffect(() => {
    if (buttonRef.current) {
      trackImpressionPromotion(
        buttonRef,
        buttonData?.link?.promotionEvents as PromotionEvents,
        pageType,
        {
          locale,
          country,
        },
      )
    }
  }, [buttonData, locale, country, pageType])

  return (
    <>
      {buttonData ? (
        <a
          href={buttonHref}
          className={buttonClasses}
          ref={buttonRef}
          onClick={handleButtonClick}
        >
          {buttonRichText}
        </a>
      ) : null}
    </>
  )
}
